<template>
  <v-data-table
    dense
    :headers="headers"
    :items="dailyBulkTransactions"
    multi-sort
    :sort-by="sortBy"
    :sort-desc="true"
    :group-by="groupBy"
    no-data-text="No Bulk Transactions"
    :mobile-breakpoint="dataTableMobileBreakpoint"
    :search="search"
  >
    <template v-slot:top>
      <div class="d-flex text-start pa-4">
        <span class="headline primary--text font-weight-medium">
          <v-icon class="primary--text" left>mdi-handshake</v-icon>Bulk
          Transactions
        </span>
        <v-spacer></v-spacer>
        <v-text-field
          class="pa-0 ma-0"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </div>
    </template>
    <template v-slot:group.header="props">
      <td
        class="text-start pa-2 font-weight-medium"
        :colspan="props.headers.length"
      >
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              <v-icon left>mdi-ferry</v-icon>
              {{ props.group }}
            </span>
          </template>
          Vessel {{ props.group }}
        </v-tooltip>
      </td>
    </template>
    <template v-slot:item.completedDateTimeLt="{ item }">
      <span>{{
        item.completedDateTimeLt | removeTAndSecondsAndFormatDate
      }}</span>
    </template>
    <template v-slot:item.quantity="{ item }">
      <span v-if="item">{{ `${item.quantity} ${item.qtyUom}` }}</span>
    </template>
    <template v-slot:item.activityStartDateTimeLt="{ item }">
      <span>{{
        item.vesselActivity.startDateTimeLt | removeTAndSecondsAndFormatDate
      }}</span>
      <span class="mx-2">
        <v-icon small color="primary">mdi-clock</v-icon>
        <v-icon small color="primary">mdi-arrow-right-bold</v-icon>
      </span>
      <span v-if="item.vesselActivity.endDateTimeLt">{{
        item.vesselActivity.endDateTimeLt | removeTAndSecondsAndFormatDate
      }}</span>
      <span v-else>Ongoing</span>
    </template>
  </v-data-table>
</template>

<script>
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';
import BulkTransactionsHelpersMixin from '../../mixins/BulkTransactionsHelpersMixin';

export default {
  name: 'DailyVoyageReportVoyageTable',
  mixins: [ResponsiveSizeHelperMixin, BulkTransactionsHelpersMixin],
  props: {
    dailyBulkTransactions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Transaction', value: 'transactionType' },
        { text: 'Bulk', value: 'bulk' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Location', value: 'location' },
        { text: 'Completed At (LT)', value: 'completedDateTimeLt' },
        { text: 'Activity Code', value: 'vesselActivity.code' },
        { text: 'Activity', value: 'vesselActivity.activityType' },
        { text: 'Activity Start/End', value: 'activityStartDateTimeLt' },
        { text: '', value: 'data-table-expand' },
      ],
      sortBy: ['vesselName', 'completedDateTimeLt'],
      groupBy: 'vesselName',
    };
  },
};
</script>
